import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBusinessData } from "../../redux/slices/memberbusinessSlice";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MerchantListTable.css"; // Create this for any custom styles
import { BellRing, SquarePen } from "lucide-react";

const statusColor = {
  Pending: "warning",
  Approved: "success",
  Rejected: "danger",
  Processing: "primary",
};

const getStatus = (member_active) => {
  if (member_active === 1) return "Approved";
  if (member_active === 2) return "Pending";
  if (member_active === 3) return "Processing";
  if (member_active === 0) return "Rejected";
  return "Pending";
};

const MerchantListTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const { data, loading, error } = useSelector((state) => state.businessData);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const totalPages = Math.ceil(data?.length / itemsPerPage);
  const currentData = data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      dispatch(fetchBusinessData(token));
    }
  }, [dispatch]);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const openModal = (company) => {
    setSelectedCompany(company);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedCompany(null);
    setShowModal(false);
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;
  if (error) return <p className="text-danger">Error: {error}</p>;

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="mb-4 text-primary fw-bold">Merchant List</h4>

          <div className="table-responsive">
            <table className="table table-hover table-bordered align-middle">
              <thead className="table-primary sticky-header">
                <tr>
                  <th>Firm Name</th>
                  <th>Address</th>
                  <th>Owner</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentData?.length ? (
                  currentData.map((partner, index) => (
                    <tr key={index}>
                      <td className="text-truncate">
                        {partner.member_firm_name || "N/A"}
                      </td>
                      <td className="text-truncate">
                        {partner.member_firm_address || "N/A"}
                      </td>
                      <td>{partner.member_name || "N/A"}</td>
                      <td>{partner.member_mobile || "N/A"}</td>
                      <td className="text-truncate">
                        {partner.member_email || "N/A"}
                      </td>
                      <td
                        className={`text-${
                          statusColor[getStatus(partner.member_active)]
                        }`}
                      >
                        {getStatus(partner.member_active)}
                      </td>
                      <td className="text-center">
                        {/* <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => openModal(partner)}
                        >
                          <FaEye /> View
                        </button> */}
                        {getStatus(partner.member_active) === "Processing" ? (
                          // <button
                          //   type="button"
                          //   className="btn btn-primary"
                          //   onClick={() =>
                          //     navigate("/copanyprocess", {
                          //       state: { company: partner },
                          //     })
                          //   }
                          // >
                          //   Process
                          // </button>

                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              navigate("/copanyprocess", {
                                state: { company: partner },
                              })
                            }
                          >
                            <SquarePen size={'15'} /> Process
                          </button>
                        ) : getStatus(partner.member_active) === "Approved" ? (
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => openModal(partner)}
                          >
                            <FaEye /> View
                          </button>
                        ) : <button
                            className="btn btn-sm btn-outline-primary"
                           
                          >
                            <BellRing size={'15'} /> Poke
                          </button>}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center text-muted">
                      No merchants found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <button
                className="btn btn-outline-primary me-2"
                onClick={handlePrev}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              {[...Array(totalPages)].map((_, idx) => (
                <button
                  key={idx}
                  className={`btn mx-1 ${
                    currentPage === idx + 1
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => handlePageClick(idx + 1)}
                >
                  {idx + 1}
                </button>
              ))}
              <button
                className="btn btn-outline-primary ms-2"
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && selectedCompany && (
        <>
          <div
            className="modal show d-block custom-modal"
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Company Details - {selectedCompany.member_firm_name}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <strong>Firm Address:</strong>{" "}
                      {selectedCompany.member_firm_address}
                    </div>
                    <div className="col-md-6">
                      <strong>Owner:</strong> {selectedCompany.member_name}
                    </div>
                    <div className="col-md-6">
                      <strong>Email:</strong> {selectedCompany.member_email}
                    </div>
                    <div className="col-md-6">
                      <strong>Phone:</strong> {selectedCompany.member_mobile}
                    </div>
                    <div className="col-md-6">
                      <strong>PAN:</strong> {selectedCompany.member_pan}
                    </div>
                    <div className="col-md-6">
                      <strong>Aadhar:</strong> {selectedCompany.member_aadhar}
                    </div>
                    <div className="col-md-6">
                      <strong>Account No:</strong>{" "}
                      {selectedCompany.member_account}
                    </div>
                    <div className="col-md-6">
                      <strong>IFSC:</strong> {selectedCompany.member_ifsc}
                    </div>
                  </div>

                  {/* Optional Images Section */}
                  <div className="row mt-4">
                    {selectedCompany.member_pan_front_url && (
                      <div className="col-md-3 text-center">
                        <img
                          src={selectedCompany.member_pan_front_url}
                          alt="PAN Front"
                          className="img-fluid rounded"
                        />
                        <p className="mt-2">PAN Front</p>
                      </div>
                    )}
                    {selectedCompany.member_pan_back_url && (
                      <div className="col-md-3 text-center">
                        <img
                          src={selectedCompany.member_pan_back_url}
                          alt="PAN Back"
                          className="img-fluid rounded"
                        />
                        <p className="mt-2">PAN Back</p>
                      </div>
                    )}
                    {selectedCompany.member_aadhar_front_url && (
                      <div className="col-md-3 text-center">
                        <img
                          src={selectedCompany.member_aadhar_front_url}
                          alt="Aadhar Front"
                          className="img-fluid rounded"
                        />
                        <p className="mt-2">Aadhar Front</p>
                      </div>
                    )}
                    {selectedCompany.member_aadhar_back_url && (
                      <div className="col-md-3 text-center">
                        <img
                          src={selectedCompany.member_aadhar_back_url}
                          alt="Aadhar Back"
                          className="img-fluid rounded"
                        />
                        <p className="mt-2">Aadhar Back</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={closeModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-modal-backdrop" onClick={closeModal}></div>
        </>
      )}
    </div>
  );
};

export default MerchantListTable;
